import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useMerchantSettings from '../hooks/useMerchantSettings';
import cardImage from '../assets/img/card.png';
import { callPostWebservice } from '../hooks/api';

const Footer = () => {

    const merchantSettings = useMerchantSettings()?.merchantSettings;
    const itemCategories = useSelector((state) => state.general.itemCategories);
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const currentYear = new Date().getFullYear();
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!e.target?.email?.value) {
            setMessage('Please enter your email');
            return;
        }

        try {

            callPostWebservice('subscribe', {
                email: e.target.email.value,
            }, (response) => {
                setMessage(response.message);
            }, (error) => {
                setMessage('You are already subscribed');
            });
        } catch (error) {
            if (error.response) {
                setMessage('An error occurred. Please try again.');
            } else {
                setMessage('An error occurred. Please try again.');
            }
        }
    };

    return (
        <>
            {/* ============================ Footer Start ================================== */}
            <footer className="dark-footer skin-dark-footer">
                <div className="footer-middle">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                                <div className="footer_widget">
                                    <img src={merchantSettings?.image} alt={merchantSettings?.legal_name || "Footer logo"} className="img-footer small mb-2" />
                                    <div className="address mt-3">
                                        {/* 3298 Grant Street Longview, TX<br />United Kingdom 75601 */}
                                        {merchantSettings?.address}
                                    </div>
                                    <a
                                        href={`callto:+${merchantSettings?.outlet?.phone}`}
                                        className="medium "
                                    >{merchantSettings?.outlet?.phone && <div className="address mt-3">
                                        {`${merchantSettings?.outlet?.phone}`}
                                    </div>
                                        }</a>
                                    <div className="address mt-3">
                                        <ul className="list-inline">

                                            {merchantSettings?.merchant_configuration?.facebook && <li className="list-inline-item"> <a target='_blank' href={`${merchantSettings?.merchant_configuration?.facebook}`} rel="noreferrer" aria-label="Follow us on Facebook"><i className="lni lni-facebook-filled" /></a></li>}
                                            {merchantSettings?.merchant_configuration?.twitter && <li className="list-inline-item"><a target='_blank' href={`${merchantSettings?.merchant_configuration?.twitter}`} rel="noreferrer" aria-label="Follow us on Twitter"><i className="lni lni-twitter-filled" /></a></li>}
                                            {merchantSettings?.merchant_configuration?.youtube && <li className="list-inline-item"><a target='_blank' href={`${merchantSettings?.merchant_configuration?.youtube}`} rel="noreferrer" aria-label="Follow us on YouTube"><i className="lni lni-youtube" /></a></li>}

                                            {merchantSettings?.merchant_configuration?.pinterest && <li className="list-inline-item"><a target='_blank' href={`${merchantSettings?.merchant_configuration?.pinterest}`} rel="noreferrer" aria-label="Follow us on Pinterest"><i className="lni lni-pinterest" /></a></li>}
                                            {merchantSettings?.merchant_configuration?.instagram && <li className="list-inline-item"><a target='_blank' href={`${merchantSettings?.merchant_configuration?.instagram}`} rel="noreferrer" aria-label="Follow us on Instagram"><i className="lni lni-instagram-filled" /></a></li>}
                                            {merchantSettings?.merchant_configuration?.linkedin && <li className="list-inline-item"><a target='_blank' href={`${merchantSettings?.merchant_configuration?.linkedin}`} rel="noreferrer" aria-label="Follow us on LinkedIn"><i className="lni lni-linkedin-original" /></a></li>}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12">
                                <div className="footer_widget">
                                    <h4 className="widget_title">Supports</h4>
                                    <ul className="footer-menu">
                                        <li><Link to="contactus">Contact Us</Link></li>
                                        <li><Link to="faqs">FAQ's</Link></li>
                                        {merchantSettings?.merchant_configuration?.terms_conditions && <li><Link to="terms">Terms &amp; Conditions</Link></li>}
                                        {merchantSettings?.merchant_configuration?.privacy_policy && <li><Link to="privacy">Privacy Policy</Link></li>}
                                        {merchantSettings?.merchant_configuration?.shipping_policy && <li><Link to="shipping">Shipping Policy</Link></li>}
                                        {merchantSettings?.merchant_configuration?.return_exchange && <li><Link to="return">Returns &amp; Exchange</Link></li>}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12">
                                <div className="footer_widget">
                                    <h4 className="widget_title">Shop</h4>
                                    <ul className="footer-menu">
                                        {itemCategories.map((category, index) => (
                                            <li key={`footer-cat-${index}`}><Link to={`/productlist?category_id=${category.id}`}>{category.name}</Link></li>
                                        ))}
                                        {/* <li><a href="home-3.html#">Men's Shopping</a></li>
                                        <li><a href="home-3.html#">Women's Shopping</a></li>
                                        <li><a href="home-3.html#">Kids's Shopping</a></li>
                                        <li><a href="home-3.html#">Furniture</a></li>
                                        <li><a href="home-3.html#">Discounts</a></li> */}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12">
                                <div className="footer_widget">
                                    <h4 className="widget_title">Company</h4>
                                    <ul className="footer-menu">
                                        <li><Link to={'aboutus'}>About</Link></li>
                                        {!isLoggedIn && <><li><Link to={'login'}>Login</Link></li>
                                            <li><Link to={'login'}>Register</Link></li></>}

                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                                <div className="footer_widget">
                                    <h4 className="widget_title">Subscribe</h4>
                                    <p>Receive updates, hot deals, discounts sent straignt in your inbox daily</p>
                                    <div className="foot-news-last">
                                        <form onSubmit={handleSubmit}>

                                            <div className="input-group">
                                                <input type="text" className="form-control" placeholder="Email Address" name="email" aria-label="Email address for newsletter" />
                                                <div className="input-group-append">
                                                    <button type="submit" className="input-group-text b-0 text-light" aria-label="Subscribe to newsletter"><i className="lni lni-arrow-right" /></button>
                                                </div>
                                            </div>
                                        </form>
                                        {message && <p>{message}</p>}

                                    </div>
                                    <div className="address mt-3">
                                        <h5 className="fs-sm text-light">Secure Payments</h5>
                                        <div className="scr_payment">
                                            <img src={cardImage} className="img-fluid" alt="Secure payment methods" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-12 col-md-12 text-center">
                                <p className="mb-0">© Copyright {currentYear} <a href="https://infinytesystems.com" target='_blank' rel="noreferrer">Infinyte Solutions . All Rights Reserved Copyright</a></p>
                            </div>

                        </div>
                    </div>
                </div>
            </footer>
            {/* ============================ Footer End ================================== */}
        </>
    )
}

export default Footer